import React from 'react';

// TODO make a component out of this function or rather move mapping logic to BE
export const getItemNameAndQuantity = (item, orderingSystem) => {
  switch (orderingSystem) {
    case 'common':
      return (
        <b>
          {item.itemQuantity}x {item.itemName}
        </b>
      );
    case 'shopify':
    case 'bigCommerce':
      return (
        <b>
          {parseInt(item.quantity)}x {item.name}
        </b>
      );
    default:
      return null;
  }
};

export const getItemPrice = (item, orderingSystem) => {
  switch (orderingSystem) {
    case 'common':
      return item.paidItemTotalPrice;
    case 'shopify':
      return item.price;
    default:
      return null;
  }
};
